module.exports = __webpack_public_path__ + "img/ic_16_flame.859143b9.svg";